import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ShopLayout from '../components/shop/ShopLayout';
import api from '../services/api';
import './CmsPage.css';
import Seo from '../components/seo/Seo';
import { cmsPageSeo } from '../config/seo';

function CmsPage() {
  const { slug: paramSlug } = useParams();
  const location = useLocation();
  const slug = paramSlug || location.pathname.replace(/^\//, '').replace(/\/$/, '');
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError('');
        const res = await api.getPageBySlug(slug);
        if (!cancelled) setPage(res?.data || res);
      } catch (e) {
        if (!cancelled) {
          setPage(null);
          setError(e.message || 'Page not found');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [slug]);

  const title = page?.title || slug?.replace(/-/g, ' ');
  const seo = cmsPageSeo(slug, page);

  return (
    <ShopLayout breadcrumbs={[{ label: title || 'Page' }]}>
      <Seo
        title={page?.meta_title || seo.title}
        description={page?.meta_description || seo.description}
        path={seo.path}
      />
      <div className="container cms-page">
        {loading && <p>Loading…</p>}
        {error && !loading && (
          <div className="cms-page__fallback">
            <h1>{title}</h1>
            <p>This page content is being prepared. Please contact us if you need assistance.</p>
          </div>
        )}
        {page && !loading && (
          <>
            <h1>{page.title}</h1>
            {page.meta_description && <p className="cms-page__lead">{page.meta_description}</p>}
            <div
              className="cms-page__content"
              dangerouslySetInnerHTML={{ __html: page.content || '<p>Content coming soon.</p>' }}
            />
          </>
        )}
      </div>
    </ShopLayout>
  );
}

export default CmsPage;
